import type { FC, ReactNode } from "react";
import { useState } from "react";
import { FiPlus } from "react-icons/fi";

export interface IAccordion {
  title: ReactNode;
  description: ReactNode;
}

export const Accordion: FC<IAccordion> = ({ title, description }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  return (
    <div className="w-full">
      <button
        onClick={toggleAccordion}
        aria-expanded={isOpen}
        className="flex items-center justify-between w-full gap-4 px-5 py-5 text-left transition-colors sm:px-6 hover:bg-surface-hover/60"
      >
        <span className="w-full text-[15px] font-semibold leading-snug break-words text-ink">{title}</span>
        <span
          className={`flex items-center justify-center w-8 h-8 border rounded-full shrink-0 transition-all duration-300 ${
            isOpen ? "rotate-45 bg-primary-soft text-primary-text border-primary/20" : "bg-surface text-ink-3 border-line"
          }`}
        >
          <FiPlus aria-hidden="true" className="w-4 h-4" />
        </span>
      </button>

      {/* Animated content */}
      <div
        className={`px-5 sm:px-6 overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 pb-6" : "max-h-0 pb-0"
        }`}
      >
        <div className="max-w-[68ch] text-sm leading-relaxed text-ink-2">{description}</div>
      </div>
    </div>
  );
};
